module.exports = __webpack_public_path__ + "static/img/banner.3c37bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/banner.png
// module id = RYpW
// module chunks = 1